/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import get from 'lodash/get';

import * as AppPropTypes from '../../lib/PropTypes';
import { pascalCase } from '../../lib/utils';
import * as BlockComponents from './index';

import styles from '../../../styles/blocks/blocks.scss';

const propTypes = {
    blocks: AppPropTypes.blocks,
    components: AppPropTypes.components,
    isNotebookSection: PropTypes.bool,
    className: PropTypes.string,
    blockClassName: PropTypes.string,
};

const defaultProps = {
    blocks: [],
    components: BlockComponents,
    isNotebookSection: false,
    className: null,
    blockClassName: null,
};

const Blocks = ({ blocks, components, isNotebookSection, className, blockClassName }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        {blocks
            ? blocks.map((block, index) => {
                  const blockType = pascalCase(block.type);
                  const blockStyle = blockType.charAt(0).toLowerCase() + blockType.slice(1);
                  // console.log(blockType);
                  // console.log(block);

                  const BlockComponent = components[blockType] || null;
                  return BlockComponent !== null ? (
                      <div
                          key={`block-${block.id}`}
                          className={classNames({
                              [styles.block]: true,
                              [styles[blockStyle]]: blockStyle,
                              [blockClassName]: blockClassName !== null,
                          })}
                      >
                          <BlockComponent
                              id={block.id}
                              isLast={index === blocks.length - 1}
                              isNotebookSection={isNotebookSection}
                              {...block}
                          />
                      </div>
                  ) : (
                      <p>NO BLOCK FOR YOU {blockType}</p>
                  );
              })
            : null}
    </div>
);

Blocks.propTypes = propTypes;
Blocks.defaultProps = defaultProps;

export default Blocks;
